/**
 * @generated SignedSource<<07ff26b05389f14454e3061984c4b3eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeploymentsTabQuery$variables = {
  changeLocator: string;
};
export type DeploymentsTabQuery$data = {
  readonly changeDeploymentConfigurations: {
    readonly " $fragmentSpreads": FragmentRefs<"ChangeBuilds_buildTypes">;
  } | null | undefined;
};
export type DeploymentsTabQuery = {
  response: DeploymentsTabQuery$data;
  variables: DeploymentsTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "changeLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "changeLocator",
    "variableName": "changeLocator"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeploymentsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BuildTypes",
        "kind": "LinkedField",
        "name": "changeDeploymentConfigurations",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChangeBuilds_buildTypes"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeploymentsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BuildTypes",
        "kind": "LinkedField",
        "name": "changeDeploymentConfigurations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BuildTypeRest",
            "kind": "LinkedField",
            "name": "buildType",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rawId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "813fbdb0fd5fdaa584e2773c5ea78664",
    "id": null,
    "metadata": {},
    "name": "DeploymentsTabQuery",
    "operationKind": "query",
    "text": "query DeploymentsTabQuery(\n  $changeLocator: String!\n) {\n  changeDeploymentConfigurations(changeLocator: $changeLocator) {\n    ...ChangeBuilds_buildTypes\n  }\n}\n\nfragment ChangeBuilds_buildTypes on BuildTypes {\n  buildType {\n    rawId\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "600a980820ebc4577aeb9d4be7d3187d";

export default node;
